<template>
  <div class="sale-normal-info-container">
    <el-card>
      <template #header>
        <TitleItem title="销售信息" />
      </template>
      <el-form label-width="125px">
        <template v-if="!(isOA && specList.length === 0)">
          <el-form-item label="规格设置">
            <el-button v-if="specList.length < 3 && !isOA" type="primary" plain @click="addSkuItem"
              >&nbsp;&nbsp;&nbsp;添加规格项(最多三项)&nbsp;&nbsp;&nbsp;</el-button
            >
            <SpecItemNormal
              v-for="specItem in specList"
              :item="specItem"
              :isOA="isOA"
              :specList="specList"
              :key="specItem.id"
              @deleteSpecItemEvent="deleteSpecItem"
            />
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="库存方式">
            <el-select v-model="stockType">
              <el-option v-for="stockItem in stockTypeArr" :key="stockItem.stockType" :label="stockItem.stockTypeName" :value="stockItem.stockType">
              </el-option>
            </el-select>
            <span v-if="stockType == 2"
              >&nbsp;&nbsp;&nbsp;<i class="el-icon-question"></i>&nbsp;用户下单,根据库存数量进行判断,用户下单不会减少系统管理库存</span
            >
            <span v-if="stockType == 1">&nbsp;&nbsp;&nbsp;<i class="el-icon-question"></i>&nbsp;用户下单,根据库存数量进行判断</span>
            <span v-if="stockType == 0">&nbsp;&nbsp;&nbsp;<i class="el-icon-question"></i>&nbsp;买家下单不会受到库存数量限制</span>
          </el-form-item>
        </template>
        <el-form-item v-if="availableSpecList.length > 0" label="价格库存">
          <el-row>
            <el-col :span="24">
              <PriceInventoryNormal :availableSpecList="availableSpecList" :isOA="isOA" ref="priceInventoryRef" />
            </el-col>
          </el-row>
        </el-form-item>
        <template v-if="stockType == 1 || (specList.length === 0 && !isOA)">
          <el-form-item v-if="specList.length == 0" label="库存" required>
            <el-input
              style="width: 202px"
              v-model="currNum"
              maxlength="9"
              placeholder="请输入商品库存"
              oninput="value=value.replace(/[^\d]/g,'')"
              @change="changeStock"
            ></el-input>
          </el-form-item>
        </template>
        <el-form-item v-if="specList.length == 0 && !(shopConfig && shopConfig.funcSettingMap.is_off_stand)" label="价格" required>
          <el-input
            style="width: 202px"
            type="number"
            :min="0"
            v-model="marketPrice"
            :disabled="isOA"
            :placeholder="!cateModel ? '先选择商品分类，才可输入' : '请输入商品价格'"
            @input="inputMarketPrice"
            @change="changeMarketPrice"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="!isOA" label="">
          <el-checkbox v-model="isPublicDisplayPrice" :true-label="1" :false-label="0">价格仅对有客户关系的买家显示</el-checkbox>
        </el-form-item>
        <el-form-item v-if="specList.length == 0" label="起订量">
          <el-input
            style="width: 202px"
            type="number"
            :min="0"
            v-model="minOrderQuantity"
            :disabled="!cateModel"
            :placeholder="!cateModel ? '先选择商品分类，才可输入' : shopConfig && shopConfig.goodsAmountDigit == '0' ? '请输入1以上的整数' : '请输入起订量'"
            @input="inputMinOrderQuantity"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="specList.length == 0" label="销售单位" required>
          <el-select style="width: 202px" filterable v-model="mUnit" placeholder="请选择" @change="unitSelectChange">
            <el-option v-for="unitItem in unitsList" :key="unitItem.unitsCode" :label="unitItem.unitsName" :value="unitItem.unitsCode"> </el-option>
          </el-select>
          <span class="pad10-l">按销售单位下单结算</span>
        </el-form-item>
        <template v-if="shopConfig && shopConfig.funcSettingMap.is_off_stand && specList.length == 0">
          <el-form-item label="计量单位">
            <span class="pad5-r">每</span>
            <el-input
              v-model="unitRatio"
              placeholder="请填写换算值"
              class="mar10-r"
              style="width: 120px"
              oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
            ></el-input>
            <el-select style="width: 140px" filterable v-model="sUnit" placeholder="请选择">
              <el-option v-for="unitItem in unitsList" :key="unitItem.unitsCode" :label="unitItem.unitsName" :value="unitItem.unitsCode"> </el-option>
            </el-select>
            <span class="pad10-l">≈1{{ spec && spec.split("/")[1] }}</span>
          </el-form-item>
          <el-form-item label="价格" :required="!isOA">
            <el-input
              style="width: 202px"
              type="number"
              :min="0"
              v-model="marketPrice"
              :disabled="isOA"
              placeholder="请输入商品价格"
              @input="inputMarketPrice"
              @change="changeMarketPrice"
            ></el-input>
            <span class="pad10-l" v-if="!cateModel">需要先选择商品分类，才可输入</span>
            <span v-else class="pad10-l">{{ this.spec }}</span>
          </el-form-item>
        </template>
        <el-form-item v-if="shopConfig && shopConfig.funcSettingMap.is_allow_unreal_sales == '1' && specList.length == 0" label="虚拟销量">
          <el-input
            v-model="salesVolumeUnreal"
            placeholder="请填写虚拟销量"
            style="width: 202px"
            oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2')"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="specList.length == 0" label="商品编码">
          <el-input style="width: 202px" v-model="relationNo" placeholder="请输入商品编码"></el-input>
        </el-form-item>
        <el-form-item v-if="shopType == 2" label="是否允许代销" required>
          <el-radio-group v-model="isDealership">
            <el-radio :label="0">不可代销</el-radio>
            <el-radio :label="1">可以代销</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitleItem from "./TitleItem.vue";
import SpecItemNormal from "./SpecItemNormal.vue";
import PriceInventoryNormal from "./PriceInventoryNormal.vue";

export default {
  components: {
    TitleItem,
    SpecItemNormal,
    PriceInventoryNormal,
  },
  data() {
    return {
      isOA: false,
      specList: [], // 规格条目数组
      availableSpecList: [], // specList过滤掉没输入规格项和规格值的数组
      stockType: 1, // 注释查看stockTypeArr里的注释
      currNum: "", // 当前库存 单规格时必填，多规格非必填
      marketPrice: "", // 价格：单规格时必填，多规格非必填
      spec: "", // 元/销售单位
      mUnit: "", //单规格时的销售单位
      sUnit: "", //单规格时的计量单位
      relationNo: "", // 货品编码
      shopType: 2, // == 2 展示 是否允许代销这行
      isDealership: 1, //是否允许代销 是否代销 0:否 1:是
      isPublicDisplayPrice: 0, // 价格：仅对客户关系 是1 否0,
      minOrderQuantity: "", // 起订量：非必填，仅支持输入数字和小数点；起订量根据商品分类校验
      unitRatio: "", // 换算值
      salesVolumeUnreal: "", // 虚拟销量
    };
  },
  computed: {
    ...mapState("publishGoods/publishGoods", ["unitsList", "goodsDetail", "spuInfoObj", "stockTypeArr", "cateModel", "shopConfig", "storeIsOa"]),
  },
  watch: {
    specList: {
      handler: function (newVal) {
        if (newVal.length > 0) {
          this.currNum = "";
          this.marketPrice = "";
          this.mUnit = "";
        }

        // this.availableSpecList = this.specList.filter((item) => item.specType && item.specValue.length);

        const { availableSpecList } = this;
        const availableSpecListTem = this.specList.filter((item) => item.specType && item.specValue.length);

        if (String(availableSpecList) != String(availableSpecListTem)) {
          this.availableSpecList = availableSpecListTem.map((item) => ({
            ...item,
            minOrderQuantity: item.minOrderQuantity == "0" ? "" : item.minOrderQuantity,
          }));
        }
      },
      deep: true,
    },
    shopConfig(newVal, oldVal) {
      console.log("shopConfig", this.shopConfig);
      this.shopType = newVal.shopType;
      if (newVal && oldVal && (newVal.goodsPriceDigit != oldVal.goodsAmountDigit || newVal.goodsPriceDigit != oldVal.goodsPriceDigit)) {
        this.minOrderQuantity = "";
        this.marketPrice = "";
      }
    },
    //商品详情数据
    goodsDetail(newVal) {
      this.currNum = newVal.firstSku.currQuantity;
      this.marketPrice = newVal.firstSku.marketPriceStr;
      this.mUnit = newVal.firstSku.mUnit;
      this.sUnit = newVal.firstSku.sUnit;
      this.spec = newVal.firstSku.spec;
      // this.isOA = newVal.firstSku.isoa == 1;
      this.stockType = newVal.firstSku.stockType;
      this.minOrderQuantity = newVal.firstSku.minOrderQuantity || "";
      this.unitRatio = newVal.firstSku.unitRatio;
      this.salesVolumeUnreal = newVal.firstSku.salesVolumeUnreal;

      this.isDealership = newVal.firstSku.isDealership;
      this.isPublicDisplayPrice = newVal.firstSku.isPublicDisplayPrice;

      this.relationNo = newVal.firstSku.relationNo;
    },
    //编辑商品的时候会有spu信息,生成多规格数据
    spuInfoObj(newVal) {
      const specialSpecArr = JSON.parse(newVal.specialSpec).data;

      this.specList = specialSpecArr.map((item) => {
        return {
          id: Date.now() + Math.floor(Math.random() * 100),
          specType: item.spec,
          specValue: item.values,
        };
      });

      this.$nextTick(() => {
        this.$refs.priceInventoryRef.editProductSetSkusData(newVal.skuList);
      });
    },
    storeIsOa(newVal) {
      this.$nextTick(() => {
        this.isOA = newVal;
        if (newVal) {
          this.marketPrice = "";
        }
      });
    },
  },
  methods: {
    //选择完计量单位后,拼接字符串
    unitSelectChange(unitsCode) {
      const unitItem = this.unitsList.find((item) => item.unitsCode === unitsCode);
      this.spec = `元/${unitItem.unitsName}`;
    },
    //增加一个规格项
    addSkuItem() {
      const specItem = {
        id: Date.now() + Math.floor(Math.random() * 100),
        specType: "",
        specValue: [],
      };
      this.specList.push(specItem);
    },
    //删除一个规格项
    deleteSpecItem(item) {
      this.specList = this.specList.filter((innerItem) => innerItem.id != item.id);
    },
    //价钱小数位不超过6位
    inputMarketPrice() {
      if (this.marketPrice.indexOf("-") != -1) {
        this.marketPrice = this.marketPrice.replaceAll("-", "");
      }

      const priceArr = this.marketPrice.split(".");
      if (priceArr.length <= 1) {
        return;
      }
      // const { goodsPriceDigit } = this.shopConfig;
      const goodsPriceDigit = 6;
      let xiaoshu = priceArr[1];
      if (xiaoshu.length > goodsPriceDigit) {
        xiaoshu = xiaoshu.substr(0, goodsPriceDigit);
        this.marketPrice = `${priceArr[0]}.${xiaoshu}`;
      }
    },
    //价钱改变后补0.整数补2个0,一位小数补一个0.
    changeMarketPrice() {
      const priceArr = this.marketPrice.split(".");
      //如果是整数,补两个0
      if (priceArr.length <= 1) {
        if (priceArr[0].length) {
          this.marketPrice = `${this.marketPrice}.00`;
        }
        return;
      }
      const xiaoshu = priceArr[1];
      if (xiaoshu.length == 1) {
        this.marketPrice = `${this.marketPrice}0`;
      }
    },
    //起订量根据分类，限制输入内容
    inputMinOrderQuantity() {
      const { goodsAmountDigit, goodsPriceDigit } = this.shopConfig;

      let valueStr = `${this.minOrderQuantity}`;
      valueStr = valueStr.replace(/[^\d.]/g, "");
      valueStr = valueStr.replace(/\.{2,}/g, ".");
      valueStr = valueStr.replace(".", "$#$");
      valueStr = valueStr.replace(/\./g, "");
      valueStr = valueStr.replace("$#$", ".");
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0,6}).*$");
      valueStr = valueStr.replace(reg, "$1$2.$3");
      valueStr = Number(valueStr) > 999999999 ? "999999999" : valueStr;
      if (valueStr.indexOf(".") < 0 && valueStr !== "" && valueStr !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        valueStr = parseFloat(valueStr);
      }
      if (goodsAmountDigit == 0 && valueStr == 0) {
        this.minOrderQuantity = "";
        return;
      }
      this.minOrderQuantity = valueStr;
      const priceArr = String(valueStr).split(".");
      if (priceArr.length <= 1) {
        return;
      }

      let xiaoshu = priceArr[1];
      if (goodsAmountDigit == 0) {
        valueStr = priceArr[0];
        this.minOrderQuantity = valueStr;
        return;
      }
      if (xiaoshu.length > goodsPriceDigit) {
        xiaoshu = xiaoshu.substr(0, goodsPriceDigit);
        this.minOrderQuantity = `${priceArr[0]}.${xiaoshu}`;
      }
    },
    //库存,取整数
    changeStock() {
      const stockArr = this.currNum.split(".");
      if (stockArr.length <= 1) {
        return;
      }
      this.currNum = stockArr[0];
    },
    subMitCheck() {
      if (this.specList.length === 0) {
        // 单规格数据拼装
        if (this.stockType == 1) {
          if (!this.currNum) {
            this.$message.error("请填写库存");
            return;
          }
        }
        if (!this.isOA) {
          if (!this.marketPrice) {
            this.$message.error("请填写价格");
            return;
          }
        }

        if (!this.mUnit) {
          this.$message.error("请选择销售单位");
          return;
        }

        const saleInfoObj = {
          stockType: this.stockType,
          currNum: this.currNum,
          marketPrice: this.marketPrice,
          mUnit: this.mUnit,
          spec: this.spec,
          minOrderQuantity: this.minOrderQuantity || 0,
          relationNo: this.relationNo,
          isDealership: this.isDealership,
          unitRatio: this.unitRatio,
          sUnit: this.sUnit,
          salesVolumeUnreal: this.salesVolumeUnreal,
          isPublicDisplayPrice: this.isPublicDisplayPrice,
        };
        //编辑商品要传skuid
        if (this.goodsDetail) {
          saleInfoObj.goodsId = this.goodsDetail.firstSku.goodsId;
        }

        //新增商品才赋值初始库存
        if (!this.goodsDetail) {
          saleInfoObj.origNum = this.currNum;
        }

        return saleInfoObj;
      }

      //如果是多规格走下面数据拼装逻辑
      if (!this.$refs.priceInventoryRef) {
        this.$message.error("规格设置未设置完");
        return;
      }
      const skuStrs = this.$refs.priceInventoryRef.subMitCheck();
      if (!skuStrs) {
        return;
      }

      //规格项 规格值数组拼装
      const specTypeStrsArr = [];
      const specValStrsArr = [];

      this.availableSpecList.forEach((specItem) => {
        specTypeStrsArr.push(specItem.specType);
        specValStrsArr.push(specItem.specValue);
      });

      const saleInfoObj = {
        specTypeStrs: JSON.stringify(specTypeStrsArr),
        specValStrs: JSON.stringify(specValStrsArr),
        skuStrs,
        isDealership: this.isDealership,
        isPublicDisplayPrice: this.isPublicDisplayPrice,
      };
      return saleInfoObj;
    },
  },
};
</script>

<style lang="scss" scoped>
.sale-normal-info-container {
  padding-top: 20px;
}
</style>
